__turbopack_context__.v({
  "blur": "LazyVideo-module-scss-module__TFu41W__blur",
  "contentVideo": "LazyVideo-module-scss-module__TFu41W__contentVideo",
  "imagesSq": "LazyVideo-module-scss-module__TFu41W__imagesSq",
  "lazyVideo": "LazyVideo-module-scss-module__TFu41W__lazyVideo",
  "logo": "LazyVideo-module-scss-module__TFu41W__logo",
  "unblur": "LazyVideo-module-scss-module__TFu41W__unblur",
});
